import PropTypes from 'prop-types'

import ResourceData from '../../game/Resource'

import images from '../Images.js'

function ResourceIcon({ resource }) {
    return (
        <div style={{
            margin: '0 2px',
            backgroundImage: `url(${images.get(resource.type).src})`,
            backgroundSize: 'contain',
            width: '32px',
            height: '32px',
            fontFamily: '"Roboto", sans-serif',
            fontWeight: 700,
            fontSize: '18px',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}><span style={{ display: 'block' }}>{resource.amount}</span></div>
    )
}

ResourceIcon.propTypes = {
    resource: PropTypes.instanceOf(ResourceData)
}

export default ResourceIcon